export const themeOptions = {
  palette: {
    type: "light",
    primary: {
      main: "#56bbad",
    },
    secondary: {
      main: "#f5bbff",
    },
    background: {
      default: "#d6cece",
    },
    warning: {
      main: "#e25335",
    },
    divider: "#56bbad",
  },
  spacing: 12,
  shape: {
    borderRadius: 6,
  },
};
